import React from "react";
import { Row, Col, Container } from "react-grid-system";
import { connect } from "react-redux";
import { Tabs } from "antd";

import "./styles.scss";
import HybrikSettings from "./Settings";
import HybrikProfiles from "./Profiles";
import HybrikJobs from "./Jobs";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";

import PricingModal from "../../components/PricingModal";

class HybrikPage extends React.Component {
  state = {};
  filters = [
    {
      name: "Queued",
      key: "queued"
    },
    {
      name: "Active",
      key: "active"
    },
    {
      name: "Completed",
      key: "completed"
    },
    {
      name: "Failed",
      key: "failed"
    }
  ];
  defaultActiveKey = "queued";
  interval = 1000;

  componentDidMount() {
    this.subscribe(this.defaultActiveKey);
  }

  componentWillUnmount() {
    clearInterval(this.id);
  }

  onChange = key => {
    this.setState({ data: null });
    clearInterval(this.id);
    if (key === "settings") return;
    this.subscribe(key);
  };

  subscribe = filter => {
    this.fetchJobs(filter);
    this.id = setInterval(this.fetchJobs.bind(null, filter), this.interval);
  };

  fetchJobs = filter => {
    CloudFlyerAPI.hybrik.fetchJobs(filter).then(({ data }) => {
      this.setState({ data });
    });
  };

  render() {
    const {
      auth: { user },
      dispatch
    } = this.props;
    const { data } = this.state;
    return (
      <Container className="hybrik" fluid>
        <PricingModal
          productName="Hybrik"
          product="hybrik"
          monthlyPricing={20}
          annuallyPricing={199}
          onClose={period => console.log("confirmed : " + period)}
        />
        <Row className="content-row">
          <Col md={11}>
            <Tabs
              defaultActiveKey={this.defaultActiveKey}
              onChange={this.onChange}
            >
              {this.filters.map(filter => (
                <Tabs.TabPane tab={`${filter.name} Jobs`} key={filter.key}>
                  <HybrikJobs filter={filter.key} data={data} />
                </Tabs.TabPane>
              ))}
              <Tabs.TabPane tab="Settings" key="settings">
                <HybrikSettings user={user} dispatch={dispatch} />
                <HybrikProfiles user={user} />
              </Tabs.TabPane>
            </Tabs>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(HybrikPage);
